/**
 * API 配置 — 西蒙的猫 v2 (前后端分离架构)
 *
 * 🔐 安全说明：
 *   - 前端只存储公开路由 URL
 *   - 不存储任何 Secret (DB 密码、AI Key、JWT Secret)
 *   - VITE_ 环境变量会被 Vite 嵌入前端 bundle，请仅放公开值
 */

// 后端 API 基础地址（通过 Nginx /api/ 代理转发）
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL || '/api/v1';

export const API_BASE: {
  BASE_URL: string;
  LOGIN: string;
  REGISTER: string;
  LOGOUT: string;
  ME: string;
  REFRESH: string;
  SEND_OTP: string;
  VERIFY_OTP: string;
  RESET_PASSWORD: string;
  OAUTH_URL: (provider: string) => string;
  PROFILE: string;
  UPDATE_PROFILE: string;
  DELETE_ACCOUNT: string;
  USER_PUBLIC: (id: string) => string;
  TRIPS: string;
  TRIP: (id: string | number) => string;
  TRIP_PLAN: (id: string | number) => string;
  DESTINATIONS: string;
  DESTINATION: (id: string) => string;
  FAVORITE: (id: string) => string;
  COMMENTS: (id: string) => string;
  AI_CHAT: string;
  AI_CONVERSATIONS: string;
  AI_CONVERSATION: (id: string) => string;
  AI_PROMPTS: string;
  UPLOAD_IMAGE: string;
} = {
  BASE_URL: API_BASE_URL,

  // ─── 认证 ───
  LOGIN: `${API_BASE_URL}/auth/login`,
  REGISTER: `${API_BASE_URL}/auth/register`,
  LOGOUT: `${API_BASE_URL}/auth/logout`,
  ME: `${API_BASE_URL}/auth/me`,
  REFRESH: `${API_BASE_URL}/auth/refresh`,
  SEND_OTP: `${API_BASE_URL}/auth/send-otp`,
  VERIFY_OTP: `${API_BASE_URL}/auth/verify-otp`,
  RESET_PASSWORD: `${API_BASE_URL}/auth/reset-password`,
  OAUTH_URL: (provider: string) => `${API_BASE_URL}/auth/oauth/${provider}/url`,

  // ─── 用户 ───
  PROFILE: `${API_BASE_URL}/users/me`,
  UPDATE_PROFILE: `${API_BASE_URL}/users/me`,
  DELETE_ACCOUNT: `${API_BASE_URL}/users/me`,
  USER_PUBLIC: (id: string) => `${API_BASE_URL}/users/${id}`,

  // ─── 旅行 ───
  TRIPS: `${API_BASE_URL}/trips`,
  TRIP: (id: string | number) => `${API_BASE_URL}/trips/${id}`,
  TRIP_PLAN: (id: string | number) => `${API_BASE_URL}/trips/${id}/plan`,

  // ─── 目的地 ───
  DESTINATIONS: `${API_BASE_URL}/destinations`,
  DESTINATION: (id: string) => `${API_BASE_URL}/destinations/${id}`,
  FAVORITE: (id: string) => `${API_BASE_URL}/destinations/${id}/favorite`,
  COMMENTS: (id: string) => `${API_BASE_URL}/destinations/${id}/comments`,

  // ─── AI ───
  AI_CHAT: `${API_BASE_URL}/ai/chat`,
  AI_CONVERSATIONS: `${API_BASE_URL}/ai/conversations`,
  AI_CONVERSATION: (id: string) => `${API_BASE_URL}/ai/conversations/${id}`,
  AI_PROMPTS: `${API_BASE_URL}/ai/prompts`,

  // ─── 上传 ───
  UPLOAD_IMAGE: `${API_BASE_URL}/upload/image`,
};

export default API_BASE;

// ─── 快捷路径别名（供 services/*.ts 使用） ───
export const API_ENDPOINTS: {
  DIARIES: string;
  DIARY_BY_ID: (id: string | number) => string;
  CHECK_RECORDS: string;
  CHECK_RECORD_BY_ID: (id: string | number) => string;
  POINTS: string;
  POINTS_CHECK_IN: string;
  POINTS_VERIFY: string;
  POINTS_HISTORY: string;
  TEMPLATES: string;
  TRIPS: string;
  TRIP_BY_ID: (id: string | number) => string;
  TRAVEL_AI_PLAN: string;
} = {
  DIARIES: `${API_BASE_URL}/diaries`,
  DIARY_BY_ID: (id: string | number) => `${API_BASE_URL}/diaries/${id}`,
  CHECK_RECORDS: `${API_BASE_URL}/check-records`,
  CHECK_RECORD_BY_ID: (id: string | number) => `${API_BASE_URL}/check-records/${id}`,
  POINTS: `${API_BASE_URL}/points`,
  POINTS_CHECK_IN: `${API_BASE_URL}/points/check-in`,
  POINTS_VERIFY: `${API_BASE_URL}/points/verify`,
  POINTS_HISTORY: `${API_BASE_URL}/points/history`,
  TEMPLATES: `${API_BASE_URL}/templates`,
  TRIPS: `${API_BASE_URL}/trips`,
  TRIP_BY_ID: (id: string | number) => `${API_BASE_URL}/trips/${id}`,
  TRAVEL_AI_PLAN: `${API_BASE_URL}/ai/generate-trip`,
};
